import React from "react";
import { useDispatch } from "react-redux";
import { setPage } from "../store/slices/pageSlice";
import SegmentSwitch from "../components/Home/HomeSwitch/SegmentSwitch";
import more from '../assets/icon/dot-grid.png';
import Profile from "../components/Home/Profile/Profile";
import gamePlaceholder from "../assets/img/pl2-2.png";

export default function GameLayout() {
    const dispatch = useDispatch();

    const handleSegmentChange = (key) => {
        if (key === 'promo') {
            // Возврат на домашний экран (Home, id: 0)
            dispatch(setPage({ id: 0, name: 'Home' }));
        }
        // Если 'crystals' – остаёмся на этой же странице
    };

    return (
        <div className="w-full h-full flex flex-col overflow-hidden pb-[30px]">
            <div className="w-full flex flex-row mt-[24px] items-center justify-between px-[15px]">
                <div className="flex-1 flex justify-center">
                    {/* На Game‑экране сразу подсвечиваем Game */}
                    <SegmentSwitch active="crystals" onChange={handleSegmentChange}/>
                </div>
                <img
                    src={more}
                    alt="More"
                    className="w-[28px] h-[28px]"
                />
            </div>

            <Profile/>

            <div className="w-full h-full flex items-center justify-center px-[16px] pt-[22px]">
                <img
                    src={gamePlaceholder}
                    alt="Game"
                    className="w-full h-auto sepia rounded-[16px]  object-cover"
                />
            </div>
        </div>
    );
}

